import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={35} height={42} fill="none" {...props}>
        <Path
            fill={designSystem.colors.neutral900}
            stroke={designSystem.colors.neutral400}
            d="M28.5.5v24.138h5.097l-.08.569-1.08 7.775-.06.432H28.5v7.29h-9.748v-7.29H.5v-6.487l.088-.13L18.57.717 18.72.5h9.78ZM11.718 24.8h7.25V14.128L11.718 24.8Z"
        />
    </Svg>
);
export { SvgComponent as FourIcon };
